export class TechnicalSubprocessObject {

  private type: string;

  constructor(private name: string, type: string, private status: string, private startDate: Date, private archived: boolean) {
    this.type = type != null ? type.toUpperCase() : null;
  }

  public getName(): string {
    return this.name;
  }

  public getType(): string {
    return this.type;
  }

  public getStatus(): string {
    return this.status;
  }

  public getStartDate(): Date {
    return this.startDate;
  }

  public isArchived(): boolean {
    return this.archived;
  }
}
